module.exports = __webpack_public_path__ + "static/media/service_lecturer.82e44e41.png";